import React from 'react';
import { NextPage } from 'next';
import Layout from '../../../components/layout';
import AccountLayout from '../../../components/account-layout';
import AccountSignupForm from '../../../components/@account-auth/account-signup-form';

const SignupPage: NextPage = () => (
  <Layout title="Sign Up" description="Sign up for an account.">
    <AccountLayout
      title="Sign Up"
      breadcrumb={{ url: '/', text: 'Back to home' }}
    >
      <AccountSignupForm />
    </AccountLayout>
  </Layout>
);

export default SignupPage;
